/*
 *
 *  session sagas
 *
 */

import {
  call,
  put,
  all,
  takeEvery
} from "redux-saga/effects"
// import { setAuthToken } from "../../helpers/index"
//race
// import store2 from "store2"
import {
  MY_ACCOUNT_LIST,
  DASHBOARD_ME_API
} from "./constants"

import {

  myAccountApiSuccess,
  myAccountApiError,
  dashboardApiError,
  dashboardApiSuccess
} from "./actions"

import {

  myAccountApi,
  dashboardMyApi
} from "./remotes"
import { post } from "../../helpers"

const machineId = localStorage.getItem("MachineId")
// const authUserDetails = localStorage.getItem("authUser")
// const userDetails = JSON.parse(authUserDetails)
// const loginDeviceId = userDetails.deviceId
console.log(machineId, "machineId from api")
// console.log(userDetails, "userDetails api")
// console.log(loginDeviceId, "machineId from api")
// console.log(authUserDetails, "authUserDetails")

export function* fetchMyAccountList() {
  try {
    const accountList = yield call(myAccountApi);
    yield put(myAccountApiSuccess(accountList));
  } catch (error) {
    yield put(myAccountApiError(error.message));
  }
}

export function* dashboardApi() {
  try {
    const dashboard = yield call(dashboardMyApi);
    yield post(dashboardApiSuccess(dashboard));
  } catch (error) {
    yield post(dashboardApiError(error.message));
  }
}

export function* watchMyAccountList() {
  yield takeEvery(MY_ACCOUNT_LIST, fetchMyAccountList);
}

export function* watchMyDashboard() {
  yield takeEvery(DASHBOARD_ME_API, dashboardApi);
}


//reset password

export default function* rootSaga() {
  yield all([

    watchMyAccountList(),
    watchMyDashboard()

  ])
}
